import { usePublishEvent } from '@/analytics/usePublishEvent';
import type { AuthError } from '@/api/AuthError';
import { AuthResponseCodes } from '@/api/types';
import { CommonRoutes } from '@/Routes';
import { useSignInStore } from '@/store/signInStore';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export const useHandleErrors = () => {
  const [, setGlobalErr] = useState('');
  const router = useRouter();
  const publishEvent = usePublishEvent();
  const updateSession = useSignInStore((s) => s.updateSession);

  return (error: unknown) => {
    if (error) {
      if ((error as AuthError).url) {
        updateSession({ redirectUrl: (error as AuthError).url });
        router.replace(CommonRoutes.REDIRECTING);
      } else {
        switch ((error as AuthError).code) {
          case AuthResponseCodes.SESSION_NOT_FOUND:
            router.replace(CommonRoutes.NO_SESSION);
            break;
          case AuthResponseCodes.OPERATION_NOT_PERMITTED:
            publishEvent('OperationNotPermittedError', 'error');
          // eslint-disable-next-line no-fallthrough
          default:
            setGlobalErr(() => {
              throw error;
            });
            break;
        }
      }
    }
  };
};
